import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Wrapper = styled.span`
  padding-block-end: ${spacers?.spacers?.[2] ?? '0.5rem'};

  /* DUX-1153 Global Styles overrides:  .t-overline-alt-normal, .t-overline-overlay */
  &.t-overline-alt-normal,
  &.t-overline-overlay {
    line-height: 1;
    display: block;
  }

  &[class*='m-ellipsis-'] {
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box; // to allow truncation with ellipsis when used with m-ellipsis-N classes
  }
`;
